import { render, staticRenderFns } from "./VgtNewPagination.vue?vue&type=template&id=683b723a"
import script from "./VgtNewPagination.vue?vue&type=script&lang=js"
export * from "./VgtNewPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports